import { render, staticRenderFns } from "./UserActivityTable.vue?vue&type=template&id=31cad672&scoped=true&"
import script from "./UserActivityTable.vue?vue&type=script&lang=js&"
export * from "./UserActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityTable.vue?vue&type=style&index=0&id=31cad672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cad672",
  null
  
)

export default component.exports